import { CheckYourEmail } from '../models/check-email.interface';

export const checkYourEmailMock: CheckYourEmail = {
  checkEmailMessage:
    "We've sent your login information to <span class='emailTextWrap'>xxx@delta.com</span>. Click the link in the email to reset your password. If you don't see the email, please check your spam or junk folders. If you reset your password multiple times, only the most recent email link will be valid.",
  headerSubTitle: '',
  headerTitle: 'Check Your Email',
  nextDisplayView: {
    button_continue: '',
    button_createPassword: '',
    button_forgotPassword: '',
    button_modal: 'Continue',
    button_loginHelp: '',
    button_resetPassword: '',
    button_sendLogin: '',
    button_wfp: '',
    nextViewName: 'loginCredentials',
    nextViewName_createPassword: '',
    nextViewName_email: '',
    nextViewName_forgotPassword: '',
    nextViewName_loginHelp: '',
    nextViewName_resetPassword: '',
    nextViewName_sendLogin: '',
    nextViewName_sqa: '',
    overlayMessage:
      "We've sent your login information to <span class='emailTextWrap'>xxx@delta.com</span>. Click the link in the email to reset your password. If you don't see the email, please check your spam or junk folders. If you reset your password multiple times, only the most recent email link will be valid.",
    refreshUrl: ''
  },
  viewName: 'checkYourEmail',
  logoUrl:
    'https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png',
  altText: 'logo',
  checkEmailMessage_Login:
    "We've sent your login information to <span class='emailTextWrap'>xxx@delta.com</span>. Click the link in the email to reset your password. If you don't see the email, please check your spam or junk folders. If you reset your password multiple times, only the most recent email link will be valid.",
  hasError: false,
  errorMessage: '',
  disabledActionButton: false,
  skipSqaContent: false
};

export const newResetPasswordCheckYourEmailMock: CheckYourEmail = {
  checkEmailMessage:
    "<p>We've sent a reset password link to your email.</p><p>If it doesn't appear within a few minutes, try again with your SkyMiles number or check your spam.</p><div class='form-data'><div class='info'> If you still haven't heard from us, you may want to verify you have entered in the correct information.</div><div class='skymiles-number'><label>Skymiles Number,Email or UserName</label><div class='value'>$$skymilesNumber$$</div></div><div class='first-name'><label>First Name </label><div class='value'>$$firstName$$</div></div><div class='last-name'><label class='label'>Last Name </label><div class='value'>$$lastName$$</div></div></div> <p>Click <span class='click-here'>here</span> if you would like to reset your password using Security Questions and Answers.</p>",
  headerSubTitle: '',
  headerTitle: 'Check Your Email',
  nextDisplayView: {
    button_continue: '',
    button_createPassword: '',
    button_forgotPassword: '',
    button_modal: 'Continue',
    button_loginHelp: '',
    button_resetPassword: '',
    button_sendLogin: '',
    button_wfp: '',
    nextViewName: 'loginCredentials',
    nextViewName_createPassword: '',
    nextViewName_email: '',
    nextViewName_forgotPassword: '',
    nextViewName_loginHelp: '',
    nextViewName_resetPassword: '',
    nextViewName_sendLogin: '',
    nextViewName_sqa: 'securityQuestionAnswers',
    overlayMessage:
      "We've sent a reset password link to your email. If it doesn't appear within a few minutes, check your spam folder.",
    refreshUrl: ''
  },
  viewName: 'newResetPasswordCheckYourEmail',
  logoUrl:
    'https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png',
  altText: 'logo',
  checkEmailMessage_Login:
    "<p>We've sent a reset password link to your email.</p><p>If it doesn't appear within a few minutes, try again with your SkyMiles number or check your spam.</p><div class='form-data'><div class='info'> If you still haven't heard from us, you may want to verify you have entered in the correct information.</div><div class='skymiles-number'><label>Skymiles Number,Email or UserName</label><div class='value'>$$skymilesNumber$$</div></div><div class='first-name'><label>First Name </label><div class='value'>$$firstName$$</div></div><div class='last-name'><label class='label'>Last Name </label><div class='value'>$$lastName$$</div></div></div> <p>Click <span class='click-here'>here</span> if you would like to reset your password using Security Questions and Answers.</p>",
  hasError: false,
  errorMessage: '',
  disabledActionButton: false,
  skipSqaContent: false
};

export const checkYourEmailWithResetPasswordValuesMock: CheckYourEmail = {
  checkEmailMessage:
    "<p>We've sent a reset password link to your email.</p><p>If it doesn't appear within a few minutes, try again with your SkyMiles number or check your spam.</p><div class='form-data'><div class='info'> If you still haven't heard from us, you may want to verify you have entered in the correct information.</div><div class='skymiles-number'><label>Skymiles Number,Email or UserName</label><div class='value'>8003818211</div></div><div class='first-name'><label>First Name </label><div class='value'>Test</div></div><div class='last-name'><label class='label'>Last Name </label><div class='value'>User</div></div></div> <p>Click <span class='click-here'>here</span> if you would like to reset your password using Security Questions and Answers.</p>",
  headerSubTitle: '',
  headerTitle: 'Check Your Email',
  nextDisplayView: {
    button_continue: '',
    button_createPassword: '',
    button_forgotPassword: '',
    button_modal: 'Continue',
    button_loginHelp: '',
    button_resetPassword: '',
    button_sendLogin: '',
    button_wfp: '',
    nextViewName: 'loginCredentials',
    nextViewName_createPassword: '',
    nextViewName_email: '',
    nextViewName_forgotPassword: '',
    nextViewName_loginHelp: '',
    nextViewName_resetPassword: '',
    nextViewName_sendLogin: '',
    nextViewName_sqa: 'securityQuestionAnswers',
    overlayMessage:
      "We've sent a reset password link to your email. If it doesn't appear within a few minutes, check your spam folder.",
    refreshUrl: ''
  },
  viewName: 'newResetPasswordCheckYourEmail',
  logoUrl:
    'https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png',
  altText: 'logo',
  checkEmailMessage_Login:
    "<p>We've sent a reset password link to your email. If it doesn't appear within a few minutes, check your spam folder.</p><p>Click <span class='click-here'>here</span> if you would like to reset your password using Security Questions and Answers.</p>",
  hasError: false,
  errorMessage: '',
  disabledActionButton: false,
  skipSqaContent: false
};
